import React from 'react'

import { Btn, CustomModal } from '../../../../components'

export default function ModalConfirmarCriacaoMovimentacao({
  visible,
  data,
  onConfirm,
  onCancel,
  isLoading,
}) {
  return (
    <CustomModal
      isVisible={visible}
      header="Confirmar Criação de Movimentação"
      onClose={onCancel}
      width="84vw"
      style={{ maxWidth: 920 }}
    >
      <div style={{ fontSize: '1rem', lineHeight: 1.7, color: '#111', marginBottom: 24 }}>
        <div style={{ color: '#C0392B', fontWeight: 700, fontSize: '1.1rem', marginBottom: 12 }}>
          Atenção!!!
        </div>

        {data ? (
          <div>
            <span>Ao salvar será criada uma </span>
            <strong>Movimentação de {data.tipoOperacao}</strong>
            <span> de </span>
            <strong>{data.quantidade}</strong>
            <span> do produto </span>
            <strong>{data.produto}</strong>
            <span> na posição </span>
            <strong>{data.posicao}</strong>
            <span> do estoque </span>
            <strong>{data.estoque}</strong>
            <span>.</span>
            <br />
            <br />
            <span>Essa movimentação </span>
            <strong>não refletirá no saldo da posição</strong>
            <span>, ou seja, </span>
            <strong>{data.textoImpacto}</strong>
            <span>.</span>
            <br />
            <br />
            <span>Este processo deve ser feito apenas para acertar e igualar o </span>
            <strong>Saldo das Movimentações</strong>
            <span> com o </span>
            <strong>Saldo Real do estoque</strong>
            <span>. Deseja realmente criar a movimentação?</span>
          </div>
        ) : null}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
        <Btn isLoading={isLoading} onClick={onConfirm} disabled={isLoading}>
          Sim
        </Btn>
        <Btn onClick={onCancel} disabled={isLoading}>
          Cancelar
        </Btn>
      </div>
    </CustomModal>
  )
}
